<template>
  <div>
    <md-app md-mode="fixed">
      <md-app-toolbar class="md-primary">

        <md-button class="md-icon-button menu-button" @click="menuVisible = !menuVisible">
          <md-icon>menu</md-icon>
        </md-button>
        <img src="/imgs/neowrk.png">

        <div class="top-buttons md-toolbar-section-start">


          <md-button to="/">
            {{$t('requests')}}
          </md-button>

        </div>
        <div class="md-toolbar-section-end">
          <md-menu :mdCloseOnClick="true" class="profile" md-align-trigger @md-opened="openProfile">
            <button id="profile" class="md-button md-icon-button" md-menu-trigger>
              <i class="md-icon md-icon-font">person</i>
            </button>

            <md-menu-content class="md-app-submenu">
              <md-list class="md-triple-line md-dense">
                <md-list-item>
                  <i class="md-icon md-icon-font md-primary">person</i>
                  <div class="md-list-item-text">
                    <span>{{userName}}</span>

                    <span>{{userEmail}}</span>
                    <a id="logout" @click="signout">{{$t('logout')}}</a>
                  </div>
                </md-list-item>
              </md-list>
            </md-menu-content>
          </md-menu>
        </div>

      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">

        <md-list>
          <div>
            <md-list-item @click="navigate('/')">
              <i class="md-icon md-icon-font">person_outline</i>
              <span class="md-list-item-text">{{$t('requests')}}</span>
            </md-list-item>
          </div>

          <md-list-item class="profile-mobile" md-expand :md-expanded.sync="menuExpanded[0]">
            <i class="md-icon md-icon-font">person</i>
            <span class="md-list-item-text">{{ userName ? userName : $t('profile')}}</span>
            <md-list slot="md-expand">
              <md-list-item class="md-inset" @click="signout">
                {{$t('logout')}}
              </md-list-item>

            </md-list>
          </md-list-item>

        </md-list>
      </md-app-drawer>

      <md-app-content>
        <slot></slot>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdminMenu',
  data: () => ({
    menuVisible: false,
    menuExpanded: []
  }),
  computed: {
    ...mapGetters('Auth', ['userName', 'userEmail']),
  },
  methods: {
    ...mapActions('Auth', ['signout']),
    async openProfile () {
      await this.$nextTick()

      let elements = Array.from(document.getElementsByClassName('md-app-submenu'))
      elements.forEach((element) => {
        element.style.top = '64px'
        element.style.right = '5px'
      })
    },
    navigate (path) {
      this.menuVisible = false
      this.$router.push(path).catch(() => {})
    },
    clearId () {
      this.menuVisible = false
      this.restoreClient()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~vue-material/src/components/MdLayout/mixins";

.md-app {
  height: 100vh;
}

.md-drawer{
  top: $toolbarHeight;
  width: $menuWidthOpened;
  @include md-layout-xsmall {
    top: $toolbarHeightSmall;

  }
}

::v-deep .md-overlay {
  top: $toolbarHeight;

  @include md-layout-xsmall {
    top: $toolbarHeightSmall;
  }
}

.md-app-submenu{
  left: auto;
  width: 100%;
}

img{
  height: calc(#{$toolbarHeight} - 23px);
  padding: 0 10px 0 10px;
}

@media only screen and (min-width: 961px) {
  .menu-button{
    display: none;
  }
}

@media only screen and (max-width: 960px) {
  img{
    height: calc(#{$toolbarHeight} - 30px);
    padding: 0 5px 0 5px;
  }

  .top-buttons, .md-toolbar-section-end{
    display: none;
  }
}

</style>
